import { defineComponent as _defineComponent } from 'vue'
import { PropType, onMounted, ref } from "vue";
import { useLineStore } from "@/stores/lineStore";
import { computed } from "@vue/reactivity";
import { IBusStop } from "@/domain/entities/busStop";
import useConvertTimeStrToMinutes from "@/use/useConvertTimeStrToMinutes";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import dayjs from "dayjs";
import getBusStopsByDate from "@/use/useGetBusStopsByDate";


const __default__ = {
  name: "TimeTableModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  busStop: {
    type: Object as PropType<IBusStop>,
    required: true,
  },
  turnId: {
    type: String,
    required: true,
  },
  nextBusStopChangeDateTime: {
    type: String,
    default: dayjs().format("YYYY-MM-DD HH:mm"),
  },
},
  emits: ["onClickCloseBtn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const lineStore = useLineStore();

const onCloseTimeTable = () => {
  emit("onClickCloseBtn");
};

// TODO 하나의 회차 uid로 셔틀노선의 모든 회차를 조회하는 API를 호출하여 회차 정보 가져오기(??)
const lineInfo = computed(() => lineStore.getLineInfoByTurnId(props.turnId));

const departureTimes = ref<string[]>([]);

const setSchedule = () => {
  lineInfo.value?.turns.forEach((turn) => {
    const busStops = getBusStopsByDate(turn, props.nextBusStopChangeDateTime);
    const targetBusStop = busStops.find(
      (busStop) => busStop.id === props.busStop.id
    );
    if (!targetBusStop) return;
    // 셔틀 노선은 조기출발 없이 모든 요일 동일한 시간으로 운행함
    departureTimes.value.push(targetBusStop.departureTime);
  });
};

const sortedDepartureTimeSchedule = computed(() => {
  return departureTimes.value.sort(
    (a, b) => useConvertTimeStrToMinutes(a) - useConvertTimeStrToMinutes(b)
  );
});

const departureTimeByHour = computed(() => {
  const timesByHour: Record<number, string[]> = {};

  sortedDepartureTimeSchedule.value.forEach((time) => {
    const [hourStr, minute] = time.split(":");
    const hour = Number(hourStr);
    if (!timesByHour[hour]) {
      timesByHour[hour] = [];
    }
    timesByHour[hour].push(minute);
  });

  // 숫자로 정렬 후, padStart를 이용해 "07"과 같은 형식 유지
  return Object.keys(timesByHour)
    .map(Number)
    .sort((a, b) => a - b)
    .map((hour) => ({
      hour: hour.toString().padStart(2, "0"),
      minutes: timesByHour[hour],
    }));
});

onMounted(() => {
  setSchedule();
});

const __returned__ = { props, emit, lineStore, onCloseTimeTable, lineInfo, departureTimes, setSchedule, sortedDepartureTimeSchedule, departureTimeByHour, NavigationBar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})